module.exports = __webpack_public_path__ + "static/media/reader_closed.e52a7df7.ico";